import type { ReactNode } from 'react';

interface CareerStepFormFieldProps {
    label: ReactNode;
    /** The translated validation message, shown under the control. */
    error?: string;
    children: ReactNode;
}

/** A field of the career step form: its label, the control, then the validation message if any. */
export const CareerStepFormField = ({ label, error, children }: CareerStepFormFieldProps) => (
    <div className={'flex flex-col gap-1.5'}>
        {label}
        {children}
        {error ? (
            <p
                role={'alert'}
                className={'text-error text-sm'}
            >
                {error}
            </p>
        ) : null}
    </div>
);
